"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeBorderImageShorthand = exports.openBorderImageShorthand = void 0;
var tslib_1 = require("tslib");
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
// border-image
var openBorderImageShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'border-image',
        parts: [
            { prop: 'border-image-source', dataType: css_data_types_1.imageSourceDataType },
            { prop: 'border-image-slice', dataType: css_data_types_1.borderImageSliceDataType, multipleItems: true },
            { prop: 'border-image-width', dataType: css_data_types_1.borderImageWidthDataType, multipleItems: true },
            { prop: 'border-image-outset', dataType: css_data_types_1.borderImageOutsetDataType, multipleItems: true },
            { prop: 'border-image-repeat', dataType: css_data_types_1.borderImageRepeatDataType, multipleItems: true },
        ],
        shorthandOpener: function (astNodes, api, parts) { return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts)(astNodes, api); },
    });
};
exports.openBorderImageShorthand = openBorderImageShorthand;
var closeBorderImageShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["", " ", " / ", " / ", " ", ""], ["", " ", " / ", " / ", " ", ""])), 'border-image-source', 'border-image-slice', 'border-image-width', 'border-image-outset', 'border-image-repeat'));
};
exports.closeBorderImageShorthand = closeBorderImageShorthand;
var templateObject_1;
//# sourceMappingURL=border-image-shorthand.js.map